import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const AddAppointmentModal = ({
  allEvents,
  show,
  onClose,
  onSave,
  eventDetails,
  setEventDetails
}) => {
  const [showCustomType, setShowCustomType] = useState(false);
  const [customType, setCustomType] = useState("");

  const getTypes = () => {
    // Get all unique types from events
    let types = new Set(allEvents.map(e => e.type));
    
    // Convert to array and format as options
    let res = Array.from(types)
      .filter(type => type !== "Tour") // Filter out Tour to add it last
      .map(type => ({ label: type, value: type }));
    
    // Add Tour option
    res.push({ label: "Tour", value: "Tour" });
    
    // Add current custom type if it exists and isn't already in the list
    if (eventDetails.type && !types.has(eventDetails.type)) {
      res.push({ label: eventDetails.type, value: eventDetails.type });
    }
    
    // Add the "Add New Type" option
    res.push({ label: "+ Add New Type", value: "add_new" });
    
    return res;
  };

  const formatToISOWithOffset = date => {
    const offsetInHours = -4; // EST offset
    const adjustedDate = new Date(
      date.getTime() + offsetInHours * 60 * 60 * 1000
    );
    return adjustedDate.toISOString().slice(0, 19); // Remove the 'Z' to avoid confusion
  };

  useEffect(() => {
    if (show) {
      setEventDetails(prevDetails => ({
        ...prevDetails,
        location: prevDetails.location || [],
        type: prevDetails.type || "",
        start: prevDetails.start || new Date(),
        end: prevDetails.end || new Date()
      }));
      console.log("event:", eventDetails);
    }
  }, [show]);

  const handleTypeChange = (e) => {
    const value = e.target.value;
    if (value === "add_new") {
      setShowCustomType(true);
      return;
    }
    setShowCustomType(false);
    setEventDetails({
      ...eventDetails,
      type: value
    });
  };

  const handleCustomTypeSubmit = () => {
    if (customType.trim()) {
      setEventDetails({
        ...eventDetails,
        type: customType.trim()
      });
      setShowCustomType(false);
      setCustomType("");
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {eventDetails.edit ? "Edit" : "Create"} Appointment
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Type</Form.Label>
            {!showCustomType ? (
              <Form.Control
                as="select"
                value={eventDetails.type}
                onChange={handleTypeChange}
              >
                <option value="">Select a type</option>
                {getTypes().map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Control>
            ) : (
              <div className="d-flex" style={{ gap: '8px' }}>
                <Form.Control
                  type="text"
                  value={customType}
                  onChange={(e) => setCustomType(e.target.value)}
                  placeholder="Enter new type"
                  style={{ flex: '2' }}
                />
                <Button 
                  onClick={handleCustomTypeSubmit}
                  className="py-0"
                  style={{ width: '70px', height: '30px' }}
                >
                  Add
                </Button>
                <Button 
                  variant="secondary" 
                  onClick={() => {
                    setShowCustomType(false);
                    setCustomType("");
                  }}
                  className="py-0"
                  style={{ width: '70px', height: '30px' }}
                >
                  Cancel
                </Button>
              </div>
            )}
          </Form.Group>
          <Form.Group>
            <Form.Label>Method</Form.Label>
            <Form.Control
              as="select"
              multiple
              value={eventDetails.location}
              onChange={e =>
                setEventDetails({
                  ...eventDetails,
                  location: Array.from(e.target.selectedOptions, option => option.value)
                })
              }
              style={{ appearance: 'none', WebkitAppearance: 'none' }}
            >
              <option value="Online">Online</option>
              <option value="Phone">Phone</option>
              <option value="In-Person">In-Person</option>
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Start Time</Form.Label>
            <Form.Control
              type="datetime-local"
              value={
                eventDetails.start instanceof Date && !isNaN(eventDetails.start)
                  ? formatToISOWithOffset(eventDetails.start)
                  : ""
              }
              onChange={e =>
                setEventDetails({
                  ...eventDetails,
                  start: new Date(e.target.value)
                })
              }
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>End Time</Form.Label>
            <Form.Control
              type="datetime-local"
              value={
                eventDetails.end instanceof Date && !isNaN(eventDetails.end)
                  ? formatToISOWithOffset(eventDetails.end)
                  : ""
              }
              onChange={e =>
                setEventDetails({
                  ...eventDetails,
                  end: new Date(e.target.value)
                })
              }
            />
          </Form.Group>
          {/* ADD THIS FEATURE LATER DOWN THE LINE. COMMENTED OUT AS WAS CONCERED ABOUT EDITS */}
          {/* <Form.Group>
            <Form.Label>Repeat For</Form.Label>
            <Select
              options={[
                { label: "Does not Repeat", value: "0" },
                { label: "1 Week", value: "1" },
                { label: "2 Weeks", value: "2" },
                { label: "3 Weeks", value: "3" },
                { label: "4 Weeks", value: "4" }
              ]}
              values={[
                { label: "Does not Repeat", value: "0" }
              ]}
              onChange={(values) => setEventDetails({ ...eventDetails, repeat: values[0]?.value || "0" })}
              placeholder="Select Repeat Interval"
            />
          </Form.Group> */}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddAppointmentModal;
